import { render, staticRenderFns } from "./OrderRecompensa.vue?vue&type=template&id=09441a12&"
import script from "./OrderRecompensa.vue?vue&type=script&lang=js&"
export * from "./OrderRecompensa.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecompensa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports